<template>
    <div>
        <Cards />
    </div>
</template>

<script>
import "@/assets/style.css"
import Cards from '@/components/Cards/HomeCards.vue'

export default {
    components: {
        Cards,
    },

    data() {
        return {
        }
    },

    async created() {
        
    },

    methods: {
        
    },

    computed: {
        
    }
}
</script>
